import { HasKind } from '@/utilities/HasKind';

import { Crumbs } from '../bakery/Crumbs';

export const kind = 'NetworkChanged';

export interface NetworkChanged extends HasKind<typeof kind> {
  online: boolean;
}

export function crumble(action: NetworkChanged): Crumbs {
  return {
    online: action.online,
  };
}
